<template>
  <div class="whole-network-page">
    <div class="whole-network-page-content">

      <div class="row person-header">
        <div class="person-name">{{$route.query.q}}</div>
        <span class="attention-btn add-attention-btn row" v-if="!existed" @click="addAttentionClick">加关注</span>
        <span class="attention-btn delete-attention-btn" v-if="existed" @click="deleteAttentionClick">已关注</span>
      </div>
      <whole-network-person-news-list :personNameData="personName"></whole-network-person-news-list>
    </div>
  </div>
</template>

<script>
import WholeNetworkPersonNewsList from '@/components/whole-network/WholeNetworkPersonNewsList';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      existed: false,
      personName: [],
      personId: -1
    };
  },
  methods: {
    addAttentionClick() {
      QuestionQuery.addMonitorPerson(this.username, this.$route.query.q).then(() => {
        this.existed = true;
      });
    },
    deleteAttentionClick() {
      QuestionQuery.deleteMonitorPerson(this.personId).then(() => {
        this.existed = false;
      });
    }
  },
  components: {
    WholeNetworkPersonNewsList
  },
  created() {
    this.username = authService.getLoggedUserName();
    this.personName = [this.$route.query.q] || [];
    QuestionQuery.getMonitorPersonStatus(this.username, this.personName).then(res => {
      this.existed = res.existed;
      this.personId = res.id;
    });
  }
};
</script>

<style lang="scss" scoped>
.whole-network-page {
  width: 100%;
  min-width: 1000px;
  min-height: 100%;
  background: #f7f7fa;
  .whole-network-page-content {
    margin: 0 auto;
    padding: 16px 0;
    width: 1200px;
    min-height: calc(100vh - 59px);
    .person-header {
      padding: 16px 24px 0;
      background-color: #ffffff;
      .person-name {
        color: #171f46;
        font-size: 32px;
        font-weight: 500;
      }
      .attention-btn {
        width: 86px;
        height: 28px;
        background: rgba(69, 168, 204, 1);
        border-radius: 2px;
        line-height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin: 10px 24px;
        text-align: center;
        padding: 6px;
        cursor: pointer;
      }
      .add-attention-btn{
        padding-left: 12px;
      }
      .add-attention-btn::before {
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        background-image: url("../assets/img/pay-attention.svg") ;
      }
      .delete-attention-btn {
        background: rgba(69, 168, 204, 0.59);
      }
    }
  }
}
</style>
